module.exports = __webpack_public_path__ + "img/car_sendai27.792b5fd0.jpg";